<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M17.6667 2.66669H6.33334C4.30829 2.66669 2.66667 4.30831 2.66667 6.33335V17.6667C2.66667 19.6917 4.30829 21.3334 6.33334 21.3334H17.6667C19.6917 21.3334 21.3333 19.6917 21.3333 17.6667V6.33335C21.3333 4.30831 19.6917 2.66669 17.6667 2.66669Z"/>
</svg>
